import styled from '@emotion/styled';
import {colors} from 'ui/config';
import {Img, MainTitle as MainTitleUI} from 'ui';
import {Link} from 'react-router-dom';

import arrowBack from 'assets/img/arrowBack.svg';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: colors.greyLight,
  paddingBottom: 140,
});

export const Image = styled(Img)({
  width: '100vw',
  height: 350,
});

export const MainTitle = styled(MainTitleUI)({
  position: 'absolute',
  left: 0,
  bottom: 56,
  zIndex: 10,
});

export const ArticleCover = styled('div')({
  position: 'relative',
  width: '100vw',
  height: 350,
});

export const BackLink = styled(Link)({
  position: 'absolute',
  top: 40,
  left: 20,
  width: 32,
  height: 32,
  backgroundColor: 'transparent',
  backgroundImage: `url(${arrowBack})`,
  backgroundPosition: 'center',
});

export const Mask = styled('div')({
  position: 'absolute',
  left: 0,
  bottom: 0,
  width: '100%',
  height: 97,
  backgroundImage: 'linear-gradient(180deg, rgba(56,40,24,0.00) 0%, #382818 100%)',
});

export const ArticleContent = styled('div')({
  padding: 20,
});
